import React from 'react';

export default React.createClass({
    propTypes: {
        data: React.PropTypes.object,
        urls: React.PropTypes.object,
        i18n: React.PropTypes.object
    },
    getInitialState() {
        return {
            loading: false,
            isAdded: this.props.data.IsAdded
        };
    },
    componentWillUnMount() {
        this.serverRequest.abort();
    },
    handleAddCourse() {
        this.setState({
            loading: true
        });

        this.serverRequest = $.get(this.props.urls.add, {
            courseId: this.props.data.CourseId
        }, (result) => {
            setTimeout(() => {
                if (result) {
                    this.setState({
                        loading: false,
                        isAdded: true
                    });
                } else {
                    this.setState({
                        loading: false
                    });
                }
            }, 1000);
        }).fail(() => {
            alert(this.props.i18n.error);
            this.setState({
                loading: false
            });
        });
    },
    renderButton() {
        if (this.state.loading) {
            return (
                <div className="c-button c-button--transparent c-courses__course__status">
                    <span>
                        <div className="c-spinner"></div>
                    </span>
                </div>
            )   ;
        } else if (this.state.isAdded) {
            return (
                <div className="c-button c-button--transparent c-courses__course__status c-courses__course__status--isAdded" disabled>
                    <span>
                        <svg className="c-button__icon c-icon c-icon--added">
                            <use xlinkHref="#added" />
                        </svg>
                    </span>
                </div>
            );
        } else {
            return (
                <div className="c-button c-button--transparent c-courses__course__status" onClick={this.handleAddCourse}>
                    <span>
                        <svg className="c-button__icon c-icon c-icon--add">
                            <use xlinkHref="#add" />
                        </svg>
                        <span className="c-button__text">{this.props.i18n.add}</span>
                    </span>
                </div>
            );
        }
    },
    render() {
        return (
            <div className="c-linkBlock">
                <div className="c-linkBlock__wrapper">
                    <div className="c-linkBlock__headers">
                        <div className="c-linkBlock__title">{this.props.data.Name}</div>
                        <div className="c-linkBlock__subtitle">{this.props.data.LastPlayed}</div>
                    </div>
                    <div className="c-linkBlock__item">
                        {this.renderButton()}
                    </div>
                </div>
            </div>
        );
    }
});
